<template>
  <div class="cmp-accounting-reports-booking-reports invoice-reports">
    <v-layout row wrap>
      <v-flex md4 xs12>
        <TextField
          type="date"
          id="start_date"
          :placeholder="$t('start_date')"
          :value="start_date"
          :showImmediate="true"
          autocomplete="off"
          @valuechanged="onDateChange"
        />
        <TextField
          type="date"
          id="end_date"
          :placeholder="$t('end_date')"
          :value="end_date"
          :showImmediate="true"
          autocomplete="off"
          @valuechanged="onDateChange"
        />
        <!-- <DatePicker
          id="start_date"
          :placeholder="$t('start_date')"
          :value="start_date"
          :showImmediate="true"
          @valuechanged="onDateChange"
        />
        <DatePicker
          id="end_date"
          :placeholder="$t('end_date')"
          :value="end_date"
          :showImmediate="true"
          @valuechanged="onDateChange"
        /> -->
        <TextField
          :id="'city'"
          v-bind="textFieldConfig"
          :value="city"
          :placeholder="$t('city')"
          @valuechanged="onTextFieldValueChange"
        />
        <Dropdown
          class="dt-dropdown"
          :options="reportData.countriesTV"
          :selected="selectedCountry"
          box
          :placeholder="$t('country')"
          v-on:selectedChange="e => onSelectedChange('selectedCountry', e)"
          :listHeight="150"
        ></Dropdown>
        <TextField
          :id="'venue'"
          v-bind="typeAheadTextFieldConfig"
          :placeholder="$t('venue')"
          :value="venue"
          :options="venueList"
          @selected="onVenueSelected"
          @valuechanged="onTextFieldValueChange"
        />
        <TextField
          :id="'promoter'"
          v-bind="typeAheadTextFieldConfig"
          :placeholder="$t('promoter')"
          :value="promoter"
          :options="promoterList"
          @selected="onPromoterSelected"
          @valuechanged="onTextFieldValueChange"
        />
        <Dropdown
          class="dt-dropdown"
          :options="reportData.usersTV"
          :selected="selectedUser"
          box
          :placeholder="$t('agent')"
          v-on:selectedChange="e => onSelectedChange('selectedUser', e)"
          :listHeight="150"
        ></Dropdown>
        <Dropdown
          class="dt-dropdown"
          :options="reportData.statusesTV"
          :selected="selectedStatus"
          box
          :placeholder="$t('status')"
          v-on:selectedChange="e => onSelectedChange('selectedStatus', e)"
          :listHeight="150"
        ></Dropdown>
      </v-flex>
      <v-flex md4 px-3 xs12>
        <div class="invoice-project-list dt-list">
          <div class="invoice-project-item dt-list-item">
            <div class="dt-checkbox v2 dt-list-item--column">
              <input
                type="checkbox"
                :name="'invoice_project'"
                :id="'invoice_project'"
                :checked="selectAllNone"
                @click="e => onInvoiceArtistSelectAllNone(e)"
              />
              <div class="checkmark"></div>
            </div>
            <div class="checkbox-label dt-list-item--column">{{$t('select_all_none')}}</div>
          </div>
          <div
            v-for="artist of reportData.artists"
            :key="artist.artist_id"
            class="invoice-project-item dt-list-item"
          >
            <div class="dt-checkbox v2 dt-list-item--column">
              <input
                type="checkbox"
                :name="'invoice_project'"
                :id="'invoice_project'"
                :checked="selectedArtists.has(artist.artist_id)"
                @click="e => onInvoiceArtistSelected(e, artist.artist_id)"
              />
              <div class="checkmark"></div>
            </div>
            <div class="checkbox-label dt-list-item--column">{{artist.artist_name}}</div>
          </div>
        </div>
      </v-flex>
      <v-flex md4 px-3 xs12>
        <div class="report-buttons">
          <button class="dt-button v1" @click.stop="onResetClick">{{$t('reset')}}</button>
          <button class="dt-button v1" @click.stop="onFinanceReportClick">{{$t('finance_report')}}</button>
          <button
            class="dt-button v1"
            @click.stop="onMoneyDetailsReportClick"
          >{{$t('money_details_report')}}</button>
          <button
            class="dt-button v1"
            @click.stop="onManagementReportClick"
            v-if="account.client.settings_show_management_report == '1'"
          >{{$t('management_report')}}</button>
          <button
            class="dt-button v1"
            v-if="account.client.settings_booking_report"
            @click.stop="onExtendedFinanceReport"
          >{{reportData.client.display_name}} {{$t('finance_report')}}</button>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import * as ActionTypes from "../../store/types";
import { mapKeyToAction } from "../../../../store/global";
import { AccountingStoreNamespace as storeNS } from "../../store";

import DatePicker from "@plugins/text-field/date-picker";
import {
  addRemoveSet,
  openWindow,
  downloadFile,
  subscribeSubject
} from "../../../../utility";
import { ReportService } from "../../services/report.service";
import { mapGetters } from "vuex";
import { EventHooks } from "../../../../plugins/text-field";
import { Subject } from "rxjs";
import { tv } from "../../../../models/text-value.model";
import { BOOKING_REPORT_TYPES } from '../../models/reportData.model';
import { createHttpGetOptions } from '../../../../services/http/http-client';

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnKeyup,
        valueChangedEvent: EventHooks.OnKeyup
      },

      typeAheadTextFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnKeyup,
        valueChangedEvent: EventHooks.OnKeyup,

        typeahead: true
      },

      start_date: "",
      end_date: "",
      city: "",
      venue: "",
      promoter: "",
      selectedCountry: null,
      selectedUser: null,
      selectedStatus: null,
      selectedArtists: new Set(),
      selectAllNone: null,

      venueSubject: new Subject(),
      promoterSubject: new Subject(),
      venueList: [],
      promoterList: [],
      selectedVenue: null,
      selectedPromoter: null,
      citySubject: new Subject(),
    };
  },
  mounted: function() {
    subscribeSubject(this, this.venueSubject, searchString => {
      if (searchString.length > 0) {
        this.fetchVenues(searchString);
      }
    });
    subscribeSubject(this, this.promoterSubject, searchString => {
      if (searchString.length > 0) {
        this.fetchPromoters(searchString);
      }
    });
    subscribeSubject(this, this.citySubject, searchString => {
      if (searchString.length > 0) {
        this.fetchCountryByCity(searchString);
      }
    });
  },
  computed: {
    ...mapGetters({
      'account': 'account',
    }),
    ...mapGetters(storeNS, {
      reportData: "reportData"
    }),
    reportPayload: function() {
      return {
        start_date: this.start_date ? this.start_date : undefined,
        end_date: this.end_date ? this.end_date : undefined,
        booking_status_id: this.selectedStatus
          ? this.selectedStatus.value
          : undefined,
        city: this.city ? this.city : undefined,
        country: this.selectedCountry ? this.selectedCountry.value : undefined,
        booking_location_id: this.selectedVenue
          ? this.selectedVenue.value
          : undefined,
        contact_id_promoter: this.selectedPromoter
          ? this.selectedPromoter.value
          : undefined,
        user_id: this.selectedUser ? this.selectedUser.value : undefined,
        artist_id: Array.from(this.selectedArtists)
      };
    }
  },
  methods: {
    onDateChange: function(name, value) {
      console.log(name, value);
      this[name] = value;
      console.log(this[name]);
    },
    onInvoiceArtistSelected: function(event, artist_id) {
      this.selectedArtists = addRemoveSet(
        event.target.checked,
        this.selectedArtists,
        artist_id
      );
    },
    onBookingDateChange: function(value) {
      console.log(value);
      this.selectedBookingDate = value;
    },
    onInvoiceArtistSelectAllNone: function(e) {
      const checked = e.target.checked;
      if (checked) {
        this.selectAllNone = true;
        this.selectedArtists = new Set(
          this.reportData.artists.map(e => e.artist_id)
        );
      } else {
        this.selectAllNone = false;
        this.selectedArtists = new Set();
      }
    },
    onTextFieldValueChange: function(name, value) {
      switch (name) {
        case "city": {
          this[name] = value;
          this.citySubject.next(value);
          break;
        }
        case "venue": {
          this.venueSubject.next(value);
        }
        case "promoter": {
          this.promoterSubject.next(value);
        }
      }
    },
    onSelectedChange: function(name, e) {
      this[name] = e;
    },
    onResetClick: function() {
      this.reset();
    },
    onFinanceReportClick: function() {
      // const url = ReportService.exportBookingFinanceReport({
      //   ...this.reportPayload
      // });
      // downloadFile(url);
      this.exportBookingReport(BOOKING_REPORT_TYPES.FINANCE_REPORT);
    },
    onMoneyDetailsReportClick: function() {
      // const url = ReportService.exportBookingMoneyDetailsReport({
      //   ...this.reportPayload
      // });
      // downloadFile(url);
      this.exportBookingReport(BOOKING_REPORT_TYPES.MONEY_DETAILS_REPORT);
    },
    onManagementReportClick: function() {
      // const url = ReportService.exportBookingManagementReport({
      //   ...this.reportPayload
      // });
      // downloadFile(url);
      this.exportBookingReport(BOOKING_REPORT_TYPES.MANAGEMENT_REPORT);
    },
    onExtendedFinanceReport: function() {
      // const url = ReportService.exportBookingExtendedFinanceReport({
      //   ...this.reportPayload
      // });
      // downloadFile(url);
      this.exportBookingReport(BOOKING_REPORT_TYPES.EXTENDED_FINANCE_REPORT);
    },
    exportBookingReport: function(reportName = BOOKING_REPORT_TYPES) {
      const url = ReportService.exportBookingReport({
        ...this.reportPayload,
        action: reportName
      });
      console.log(url, this.reportPayload);
      // return;
      downloadFile(url);
    },
    reset: function() {
      this.start_date = "";
      this.end_date = "";
      this.city = "";
      this.venue = "";
      this.promoter = "";
      this.selectedCountry = null;
      this.selectedUser = null;
      this.selectedStatus = null;
      this.selectedArtists = new Set();
      this.selectAllNone = null;

      this.venueList = [];
      this.promoterList = [];
      this.selectedVenue = null;
      this.selectedPromoter = null;
    },
    fetchVenues: async function(search) {
      const venues = await ReportService.findLocation({
        search
      });
      this.venueList = (venues.data.locationlist || []).map(
        tv("booking_location_name", "booking_location_id")
      );
    },
    onVenueSelected: function(selected) {
      this.selectedVenue = selected;
      this.venue = this.selectedVenue.text;
    },
    fetchPromoters: async function(search) {
      const promoters = await ReportService.findPromoter({
        search
      });
      console.log(promoters.data);
      this.promoterList = (promoters.data.promoterlist || []).map(
        tv("company_name", "promoter_id")
      );
    },
    onPromoterSelected: function(selected) {
      this.selectedPromoter = selected;
      this.promoter = this.selectedPromoter.text;
    },
    fetchCountryByCity: async function(search) {
      const countriesData = await ReportService.findCountryByCity({
        city: search
      });
      console.log(countriesData.data);
      const countries = countriesData.data.countries;

      if (countries && countries.length > 0) {
        this.selectedCountry = {
          text: countries[0].country,
          value: countries[0].country,
        };
      }
    }
    //MARK: Methods1
  }
};
</script>

<style lang="scss">
.cmp-accounting-reports-booking-reports {
  .dt-list {
    height: calc(100vh - 120px);
    overflow-y: auto;
    .dt-list-item {
      .dt-list-item--column {
        &:nth-child(1) {
          flex: 0.2 !important;
        }
      }
    }
  }
  .report-buttons {
    display: flex;
    flex-direction: column;
    button {
      text-transform: uppercase;
    }
  }

  .dt-dropdown {
    margin: 4px;
  }
}
</style>